import { useState } from "react";
import { GrTextAlignFull } from "react-icons/gr";
import { If } from "~/components/v3/Conditional";
import { BASE_INPUT_STYLES } from "~/components/v3/themed/BASE_STYLE_DEFINITIONS";
import Modal from "~/components/v3/themed/Modal";
import { Button } from "~/components/v4/themed/Button";
import { cn } from "~/utils/fontsConfig";
import { CustomizableLayout } from "~/types/CustomizableLayout";

const DescriptionTextPopup = ({
    children,
    value,
    customization,
}: {
    children: React.ReactNode;
    value?: string | null;
    customization?: CustomizableLayout;
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <span className="w-inherit">
            <button
                className={cn(
                    "flex min-h-10 w-full flex-col justify-start rounded-[0.625rem] bg-v3-N-500 px-3 py-3 text-base tracking-wide shadow-none transition-colors",
                    "m-0 text-start text-white hover:bg-v3-N-400",
                    "min-h-16 md:text-sm",
                    customization?.inputClassName,
                )}
                onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(true);
                }}
            >
                <span className="flex items-center gap-2">
                    <GrTextAlignFull />
                    Description
                </span>
                <If condition={!!value && value.length > 0}>
                    <p className="line-clamp-1 text-xs text-v3-N-300">
                        {value}
                    </p>
                </If>
                <If condition={!value || value.length === 0}>
                    <p className="line-clamp-1 pt-2 text-xs text-v3-N-300">
                        Add description
                    </p>
                </If>
            </button>
            <Modal
                open={isOpen}
                onOpenChange={setIsOpen}
                title="Event Description"
                className="z-[900]"
                customization={customization}
                footer={
                    <Button
                        variant="secondary"
                        className="px-4"
                        onClick={() => setIsOpen(false)}
                    >
                        Done
                    </Button>
                }
            >
                {children}
            </Modal>
        </span>
    );
};

export default DescriptionTextPopup;
